import _ from "lodash";
import Validator from "validatorjs";
import React, { Component } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

import { FormControl } from "../../../../facturotopia";

class PersonalizarSerieFolioForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      isTouched: false,
      showInputs: false,
      validator: new Validator({}, this.rules),
    };
  }

  componentDidMount() {
    const { data } = this.props;

    this.populateSeries(data);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEmpty(this.props.data.Emisor) && this.props.data.Emisor.id !== prevProps.data.Emisor.id) {
      this.populateSeries(this.props.data);
    }
  }

  populateSeries(data) {
    const { Emisor } = data;

    const { series = [] } = Emisor || {};

    const show = !_.isEmpty(series) && series.length > 0;

    const filtered = series.filter((item) => {
      return item.tipo === data.TipoDeComprobante.toLowerCase();
    })
    .map((item) => {
      return {
        label: item.serie,
        value: item.serie,
      };
    });

    const sorted = _.sortBy(filtered, "label");

    const options = [
      {
        label: "Selecciona",
        value: "",
      },
      {
        label: "Personalizar serie",
        value: "personalizar",
      },
    ].concat(sorted);

    this.setState({
      hasSeries: show,
      showSeries: show,
      showInputs: !show,
      options,
    });
  }

  get rules() {
    const { isTouched } = this.state;

    const Serie = ["string"];
    const Folio = ["string"];

    return {
      SerieFolioSelect: !!isTouched ? ["required"] : [],
      Serie: !!isTouched ? ["required"].concat(Serie) : Serie,
      Folio: !!isTouched ? ["required"].concat(Folio) : Folio,
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnSerieFolioChange = (value) => {
    if (!_.isEmpty(value)) {
      const show = value.SerieFolioSelect === "personalizar" ? true : false;

      this.setState({
        isTouched: true,
      });

      if (!!show) {
        this.setState({
          showInputs: show,
          showSeries: false,
        });
      } else {
        const data = {
          ...this.state.data,
          Serie: value.SerieFolioSelect,
        };

        this.setState({
          SerieFolioSelect: value.SerieFolioSelect,
        });

        this.handleOnChange(data);
      }
    }
  };

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    };

    const validator = this.validate(data);
    const isValid = validator.passes();

    this.props.onChange({
      ...data,
    });

    const isTouched = !_.isEmpty(data.Serie) && !_.isEmpty(data.Folio);

    this.setState({
      data,
      isValid: isValid,
      isTouched: isTouched,
    });
  };

  handleOnChangeSelect = () => {
    this.setState({
      data: {},
      showSeries: true,
      SerieFolioSelect: "",
      isTouched: false,
    });
  };

  render() {
    const {
      data,
      hasSeries = false,
      showSeries,
      showInputs,
      options,
      validator,
      SerieFolioSelect = null,
    } = this.state;

    return (
      <div className="mt-3">
        <Form autoComplete="off">
          {!!showSeries && (
            <Row>
              <Col>
                <FormControl
                  type="select"
                  label="Seleccionar Serie"
                  name="SerieFolioSelect"
                  placeholder=""
                  help={ !!SerieFolioSelect ? `El número de folio se agrega de forma automática.` : "" }
                  validator={ validator }
                  options={ options }
                  autoFocus
                  value={ SerieFolioSelect }
                  onChange={ this.handleOnSerieFolioChange }
                />
              </Col>
            </Row>
          )}

          {!showSeries && !!showInputs && (
            <>
              <Row>
                <Col>
                  <FormControl
                    type="text"
                    label="Serie"
                    name="Serie"
                    placeholder=""
                    help=""
                    autoFocus
                    validator={ validator }
                    value={ data.Serie }
                    onChange={ this.handleOnChange }
                  />
                </Col>

                <Col>
                  <FormControl
                    type="text"
                    label="Folio"
                    name="Folio"
                    placeholder=""
                    help=""
                    validator={ validator }
                    value={ data.Folio }
                    onChange={ this.handleOnChange }
                  />
                </Col>
              </Row>

              {!!hasSeries && (
                <Row>
                  <Col>
                    <Button type="button" variant="link" onClick={ this.handleOnChangeSelect }>
                      Seleccionar una de mis series
                    </Button>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Form>
      </div>
    );
  }
}

export default PersonalizarSerieFolioForm;
